




















































import Vue from 'vue';
import { Transaction, TransactionStatus } from '@/common/types/transactions.types';
import { refundClass, dateFormattedValue } from '@/common/util/dashboard.util';
import TransactionDetails from '../transactions/components/TransactionDetails.vue';

export default Vue.extend({
  props: {
    data: {
      required: true,
    },
  },
  data() {
    return {
      selectedTransactionId: '' as string,
      drawer: false,
    };
  },
  methods: {
    refundClass,
    dateFormattedValue,
    getAmount(item: Transaction) {
      return item.status === TransactionStatus.REFUNDED
        || (item.refundedAmount && item.refundedAmount !== 0 && item.originalTransactionId)
        ? `($${(this.$options.filters as any).dollarsAndCents(item.refundedAmount)})`
        : `$${(this.$options.filters as any).dollarsAndCents(item.amount)}`;
    },
    viewTransaction(transaction: Transaction) {
      this.selectedTransactionId = transaction.id!;
      this.drawer = !this.drawer;
    },
    refreshDashboard() {
      this.$emit('refreshDashboard');
    },
  },
  components: {
    TransactionDetails,
  },
});
